import React from 'react';
import EvaluationLayout from '../../components/EvaluationLayout';
import { ModelComparisonDashboard } from '../../components/ModelComparison';

const ModelComparison = () => {
  return (
    <EvaluationLayout>
      <ModelComparisonDashboard />
    </EvaluationLayout>
  );
};

export default ModelComparison;
